<template>
  <div>
    <Modal v-model="modal" :width="modalWidth" class-name="export-modal" :closable="false" :mask-closable="false">
      <div class="flow-modal-title" slot="header">
        <span style="font-size: 17px">{{ title }}</span>
        <span @click="closeModal()" style="position: absolute; right: 6px; cursor: pointer">
          <i class="ivu-icon ivu-icon-ios-close"></i>
        </span>
      </div>
      <div class="form">
        <Form ref="exportOptionForm" :label-width="150" :model="exportOption" :rules="ruleValidate" label-colon>
          <Row>
            <Col span="22">
              <FormItem label="文件类型" prop="fileType">
                <RadioGroup v-model="exportOption.fileType" size="large">
                  <Radio label="0">Excel文档</Radio> &nbsp;
                  <Radio label="1">XML文档</Radio>
                </RadioGroup>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="22">
              <FormItem label="导出文件名称" prop="fileName">
                <Input v-model="exportOption.fileName" maxlength="50" show-word-limit />
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span="22">
              <FormItem label="选择导出字段" prop="exportFields">
                <Checkbox :indeterminate="checkAllIndeterminate" :value="checkAll" size="large" @click.prevent.native="handleCheckAll">全选</Checkbox>
                <CheckboxGroup v-model="exportOption.exportFields" size="large" @on-change="handleCheckGroupChange">
                  <Checkbox v-for="item in allowExportFields" :key="item.name" :label="item.name">{{ item.description }}</Checkbox>
                </CheckboxGroup>
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col>
              <FormItem label="导出数据页设置" prop="pageRange">
                从&nbsp;
                <InputNumber :min="1" :max="pageCount" :precision="0" v-model="exportOption.pageRange.fromPageNo" style="width: 100px" />
                &nbsp;页&nbsp; 至&nbsp;
                <InputNumber :min="1" :max="pageCount" :precision="0" v-model="exportOption.pageRange.toPageNo" style="width: 100px" />&nbsp;页 （&nbsp;共&nbsp;{{ pageCount }}&nbsp;页）
              </FormItem>
            </Col>
          </Row>
        </Form>
      </div>
      <div slot="footer" class="model-footer">
        <Button size="large" @click="closeModal">取消</Button>
        <Button type="primary" size="large" :loading="modal_loading" @click="confirmExport">确定</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Qs from 'qs'

export default {
  name: 'grid-export-opt',
  props: {
    modalWidth: {
      type: Number,
      default: 900
    },
    modalHeight: {
      type: Number,
      default: 600
    },
    gridAllShowFields: {
      type: Array,
      default() {
        return []
      }
    },
    selectedRows: {
      type: Array,
      default() {
        return []
      }
    },
    rowMark: {
      type: String,
      default: ''
    },
    pageSize: {
      type: Number,
      default: 10
    },
    gridRequestParams: {
      type: Object,
      default() {
        return null
      }
    },
    exportMaxCount: {
      type: Number,
      default: 2000
    },
    exportOption: {
      type: Object,
      default() {
        return {
          fileType: '0',
          exportFields: [],
          pageRange: {
            fromPageNo: 1,
            toPageNo: 1
          }
        }
      }
    }
  },
  data() {
    const validateExportFields = function (rule, value, callback) {
      if (!value || value.length <= 0) {
        callback(new Error('请选择导出字段'))
      } else {
        callback()
      }
    }
    return {
      modal: true,
      title: '导出数据',
      totalCount: 0,
      modal_loading: false,
      checkAll: true,
      checkAllIndeterminate: false,
      ruleValidate: {
        fileName: [{ required: true, message: '文件名称不能为空', trigger: 'blur,change' }],
        pageRange: [{ validator: this.validatePageRange, trigger: 'blur,change' }],
        exportFields: [{ validator: validateExportFields, trigger: 'blur,change' }]
      }
    }
  },
  mounted() {
    // 查询导出数据共有多少页
    this.queryExportDataCount()
    // 默认选中所有字段
    this.defCheckedAllFields()
  },
  computed: {
    allowExportFields() {
      if (this.gridAllShowFields) {
        return this.gridAllShowFields.filter(el => el.isExport === '1')
      } else {
        return []
      }
    },
    pageCount() {
      return Math.ceil(this.totalCount / this.pageSize)
    }
  },
  methods: {
    queryExportDataCount() {
      if (!this.gridRequestParams) {
        this.$Notice.error({
          title: '错误提示',
          desc: '查询数据参数为空'
        })
      } else {
        let params = { ...this.gridRequestParams }
        params.pageNo = 1
        params.pageSize = 0
        this.$store.dispatch('postRequest', { url: '/bsp-com/com/datagrid/getQueryPageData', params: params }).then(resp => {
          if (resp.success) {
            this.totalCount = resp.total
            // 设置默认的导出结束页
            if (this.totalCount > this.exportMaxCount) {
              this.exportOption.pageRange.toPageNo = Math.floor(this.exportMaxCount / this.pageSize)
            } else {
              this.exportOption.pageRange.toPageNo = Math.ceil(this.totalCount / this.pageSize)
            }
          } else {
            this.$Notice.error({
              title: '错误提示',
              desc: resp.msg
            })
          }
        })
      }
    },
    defCheckedAllFields() {
      if (this.allowExportFields) {
        let allowExportFieldNames = this.allowExportFields.map(e => e.name)
        this.exportOption.exportFields.push(...allowExportFieldNames)
      }
      // 默认全选，同步全选框状态
      this.updateCheckAllStatus()
    },
    handleCheckAll() {
      if (this.checkAllIndeterminate) {
        this.checkAll = false
      } else {
        this.checkAll = !this.checkAll
      }
      this.checkAllIndeterminate = false
      if (this.checkAll) {
        this.exportOption.exportFields = this.allowExportFields.map(e => e.name)
      } else {
        this.exportOption.exportFields = []
      }
    },
    handleCheckGroupChange() {
      this.updateCheckAllStatus()
    },
    updateCheckAllStatus() {
      let selectedCount = this.exportOption.exportFields.length
      let totalCount = this.allowExportFields.length
      if (selectedCount === 0) {
        this.checkAll = false
        this.checkAllIndeterminate = false
      } else if (selectedCount === totalCount) {
        this.checkAll = true
        this.checkAllIndeterminate = false
      } else {
        this.checkAll = false
        this.checkAllIndeterminate = true
      }
    },
    validatePageRange(rule, value, callback) {
      if (!value || !value.fromPageNo || !value.toPageNo) {
        callback(new Error('请设置导出数据页'))
        return
      }
      if (value.fromPageNo > value.toPageNo) {
        callback(new Error('导出起始页号不能大于结束页号'))
        return
      }else{
           callback()
      }
      // 校验数据量不能超过this.exportMaxCount条
      // if (this.totalCount <= this.exportMaxCount) {
      //   callback()
      //   return
      // }
      // if ((value.toPageNo - value.fromPageNo + 1) * this.pageSize > this.exportMaxCount) {
      //   callback(new Error('导出的数据量不能超过' + this.exportMaxCount))
      // } else {
      //   callback()
      // }
      // callback()
    },
    closeModal() {
      this.modal = false
      this.$emit('closeModal')
    },
    getExportNum(toPageNo, fromPageNo) {
      // 如果是最后一页 判断最后一页多少条数据
      // 不是最后一页直接乘页码 (value.toPageNo - value.fromPageNo + 1) * this.pageSize
      let exportTotal = 0
      if (toPageNo == this.pageCount) {
        exportTotal = this.totalCount - (fromPageNo - 1) * this.pageSize
      } else {
        exportTotal = (toPageNo - fromPageNo + 1) * this.pageSize
      }
      console.log(exportTotal,this.pageCount,'this.pageCount()')
      return exportTotal
    },
    confirmExport() {
      console.log(121212, this.exportMaxCount, this.pageCount, this.rowMark,'this.selectedRows.length')
      this.$refs['exportOptionForm'].validate(valid => {
        console.log(valid,'valid')
        if (valid) {
          this.modal_loading = true
          let opts = this.exportOption
          let params = { ...this.gridRequestParams }
          params.fileType = opts.fileType
          params.fileName = opts.fileName
          params.exportFields = opts.exportFields.join(',')
          params.fromPageNo = opts.pageRange.fromPageNo
          params.toPageNo = opts.pageRange.toPageNo
          params.pageSize = this.pageSize
          params.exportMaxCount = this.exportMaxCount
    
          delete params.pageNo
          if (this.selectedRows && this.selectedRows.length > 0 && this.rowMark) {
            let rowMarkLowerCase = this.rowMark.toLowerCase()
            let rowMarkValArr = this.selectedRows.map(row => row[rowMarkLowerCase])
            params['rowMarkVals'] = rowMarkValArr.join(',')
          }
          console.log((params.toPageNo - params.fromPageNo + 1) * this.pageSize, this.exportMaxCount,this.pageCount, 'this.selectedRows.length')
          let num = this.getExportNum(params.toPageNo, params.fromPageNo)
          let url = '/bsp-com/com/datagrid/exportGridData'
          params.totalPage= Math.ceil(num / this.pageSize)// 导出列表数据总页数,
          params.totalNum=this.totalCount  // 导出列表数据数,
          params.totalExportNum=num //导出数据数
          if (num > 2000) {
            url = '/bsp-com/com/datagrid/export/exportGridDataTask'
            this.$Modal.confirm({
              title: '导出提示',
              content: '导出数量超过2000条,需要创建导出任务,导出任务创建完成后,可通过"导出数据下载"按钮对文件进行下载，是否创建导出任务？',
              loading: true,
              onOk: async () => {
                this.downFile(params,url,true,opts )
              }
            })
            this.modal_loading = false
          } else {
            url = '/bsp-com/com/datagrid/exportGridData'
            this.downFile(params,url,false,opts )
          }
          
        } else {
          this.$Message.error('表单验证失败')
        }
      })
    },
    downFile(params,url,tag,opts){
      this.$store
            .dispatch('downloadPostRequest', {
              url: url,
              params: Qs.stringify(params),
              responseType: 'blob'
            })
            .then(resp => {
              const data = resp
              console.log(data,'data')
              if(tag){
                this.$Message.success('导出任务创建成功！')
                this.$Modal.remove()
                this.modal_loading = false
                this.closeModal()
              }else{
              if (data['type'] === 'text/plain' || data['type'] === 'application/json') {
                // 导出失败，返回的是错误消息
                data.text().then(msg => {
                  this.$Notice.error({
                    title: '错误提示',
                    desc: msg ? msg : '导出列表数据异常'
                  })
                })
                this.modal_loading = false
              } else {
                // 导出成功，返回的是要导出的文件
                const url = window.URL.createObjectURL(data)
                const a = document.createElement('a')
                a.href = url
                a.download = opts.fileName
                document.body.appendChild(a)
                a.click()
                window.URL.revokeObjectURL(url)
                document.body.removeChild(a)
                this.modal_loading = false
                this.closeModal()
              }
            }
            })
            .catch(error => {
              if (error) {
                console.log(error)
              }
              this.modal_loading = false
            })
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .export-modal .ivu-modal-body,
/deep/ .export-modal .ivu-modal-header {
  padding: 0 !important;
}
/deep/ .ivu-modal-body {
  max-height: 440px;
  overflow-y: auto;
}
/deep/ .export-modal .ivu-modal-footer {
  padding: 8px 18px 8px 18px;
}
/deep/ .export-modal .ivu-icon-ios-close {
  font-size: 32px;
  line-height: 40px;
}
/deep/ .export-modal .ivu-modal-footer {
  background: #f7faff;
  border-color: #cee0f0;
}

/* 自定义弹窗底部按钮样式重置 */
.export-modal .model-footer /deep/ .ivu-btn-primary {
  font-size: 16px;
  min-width: 80px;
  height: 36px;
  opacity: 1;
  background: #2b5fd9;
  border-radius: 2px;
  margin: 0 8px;
}
.export-modal .flow-modal-title {
  height: 40px;
  background: #2b5fda;
  width: 100%;
  text-indent: 1em;
  color: #fff;
  line-height: 40px;
}
.export-modal .model-footer button {
  font-size: 16px;
  min-width: 80px;
  height: 36px;
  opacity: 1;
  border-radius: 2px;
  margin: 0 8px;
}

/deep/ .ivu-checkbox-group-item {
  width: 160px;
  font-size: 16px;
}

/deep/ .ivu-form .ivu-form-item-label {
  font-size: 16px;
}

/deep/ .ivu-form-item-content {
  font-size: 16px;
}

/deep/ .export-modal *::-webkit-scrollbar {
  width: 10px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 10px;
}

/deep/ .export-modal *::-webkit-scrollbar-thumb {
  border-radius: 3px;
  background: #b7c7dd;
}

/deep/ .export-modal *::-webkit-scrollbar-track {
  border-radius: 3px;
  background: #ededed;
}
</style>


// WEBPACK FOOTER //
// src/component/data-grid/components/grid-export-opt.vue